module.exports = __webpack_public_path__ + "img/logo.6854f94b.png";